import { REQUEST, FAILURE, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const CHANGE_REASSIGN_TASK_STATUS = createRequestTypes('CHANGE_REASSIGN_TASK_STATUS');
export const changeReassignTaskStatus = {
  request: data => action(CHANGE_REASSIGN_TASK_STATUS[REQUEST], data),
  success: data => action(CHANGE_REASSIGN_TASK_STATUS[SUCCESS], { data }),
  failure: error => action(CHANGE_REASSIGN_TASK_STATUS[FAILURE], { error }),
};

export const GET_USER_ACCOUNT_TRADE_OPEN = createRequestTypes('GET_USER_ACCOUNT_TRADE_OPEN');
export const getUserAccountTradeOpen = {
  request: (id, idAccount, search = '') => action(GET_USER_ACCOUNT_TRADE_OPEN[REQUEST], { id, idAccount, search }),
  success: data => action(GET_USER_ACCOUNT_TRADE_OPEN[SUCCESS], { data }),
  failure: error => action(GET_USER_ACCOUNT_TRADE_OPEN[FAILURE], { error }),
};

export const GET_USER_ACCOUNT_TRADE_CLOSED = createRequestTypes('GET_USER_ACCOUNT_TRADE_CLOSED');
export const getUserAccountTradeClosed = {
  request: (id, idAccount, search = '') => action(GET_USER_ACCOUNT_TRADE_CLOSED[REQUEST], { id, idAccount, search }),
  success: data => action(GET_USER_ACCOUNT_TRADE_CLOSED[SUCCESS], { data }),
  failure: error => action(GET_USER_ACCOUNT_TRADE_CLOSED[FAILURE], { error }),
};

export const GET_USER_ACCOUNT_TRADE_DELAYED = createRequestTypes('GET_USER_ACCOUNT_TRADE_DELAYED');
export const getUserAccountTradeDelayed = {
  request: (id, idAccount, search = '') => action(GET_USER_ACCOUNT_TRADE_DELAYED[REQUEST], { id, idAccount, search }),
  success: data => action(GET_USER_ACCOUNT_TRADE_DELAYED[SUCCESS], { data }),
  failure: error => action(GET_USER_ACCOUNT_TRADE_DELAYED[FAILURE], { error }),
};
